import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Typography} from '@mui/material';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {selectUserGroup} from '../../redux/slices/user';
import {
  faKeyboard,
  faCheck,
  faFont,
  faBook,
  faScalpelLineDashed,
  faChalkboardTeacher,
  faLock,
  faLineColumns,
  faScreenUsers,
  faPersonChalkboard,
} from '@fortawesome/pro-light-svg-icons';

import {
  APP_WORD_WORK,
  APP_WORD_SORT,
  APP_WORD_DIVISION,
  APP_READING,
  APP_ASSESSMENT,
  APP_WRITING,
  FEATURES,
} from '../../constants';

import styles from '../css/MenuDrawer.module.css';

export default function MenuDrawer({isMenuOpen, toggleMenu}) {
  const history = useHistory();
  const [open, setOpen] = useState(true);
  const userGroup = useSelector(selectUserGroup);

  function handleExercisesClick() {
    setOpen(!open);
  }

  function exerciseURL(type) {
    return `/builder/exercises?type=${type}`;
  }

  function hasFeature(feature) {
    return userGroup?.tier?.features.includes(feature);
  }

  function renderMenuItem(title, navigateTo, fontAwesomeIcon, feature, isNested = false) {
    const isEnabled = hasFeature(feature);
    return (
      <ListItem disablePadding>
        <ListItemButton
          disabled={!isEnabled}
          className={isNested ? styles.nested : null}
          onClick={() => {
            toggleMenu(false);
            history.push(navigateTo);
          }}
        >
          <ListItemIcon>
            {isEnabled ? <FontAwesomeIcon icon={fontAwesomeIcon} /> : <FontAwesomeIcon icon={faLock} />}
          </ListItemIcon>
          <ListItemText primary={title} />
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    <Drawer open={isMenuOpen} onClose={() => toggleMenu(false)}>
      <div className="p-10">
        <Typography variant="h5" className="clr-brandorange">
          Flamingo Learning
        </Typography>
        <Typography>v2.1</Typography>
      </div>
      <Divider />
      <List className={styles['menu-list']}>
        {renderMenuItem('Make Assignments', '/builder/session/create', faPersonChalkboard, FEATURES.SESSION)}
        {renderMenuItem('Students', '/builder/students', faScreenUsers, FEATURES.STUDENT)}
        {renderMenuItem('Lessons', '/builder/lessons', faChalkboardTeacher, FEATURES.LESSON)}

        <ListItem button onClick={handleExercisesClick}>
          <ListItemText primary="Exercises" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {renderMenuItem('Assessments', exerciseURL(APP_ASSESSMENT), faCheck, FEATURES.EXERCISE_ASSESSMENT, true)}
            {renderMenuItem('Reading', exerciseURL(APP_READING), faBook, FEATURES.EXERCISE_READING, true)}
            {renderMenuItem(
              'Word Division',
              exerciseURL(APP_WORD_DIVISION),
              faScalpelLineDashed,
              FEATURES.EXERCISE_WORD_DIVISION,
              true,
            )}
            {renderMenuItem('Word Sort', exerciseURL(APP_WORD_SORT), faLineColumns, FEATURES.EXERCISE_WORD_SORT, true)}
            {renderMenuItem('Word Work', exerciseURL(APP_WORD_WORK), faFont, FEATURES.EXERCISE_WORD_WORK, true)}
            {renderMenuItem(
              'Writing for Reading',
              exerciseURL(APP_WRITING),
              faKeyboard,
              FEATURES.EXERCISE_WRITING,
              true,
            )}
          </List>
        </Collapse>
      </List>
    </Drawer>
  );
}
